import { ALL_BUSINESS_UNITS_ID } from 'framework-listing-lib/constants/businessUnits';

/**
 * Will return true when:
 *   - All individual BU options are selected
 *   - "All business units" option is not selected
 */
function getHasSelectedAllOptionsExceptAllBUsOption({
  allBusinessUnits,
  newValue
}) {
  return Boolean(newValue && newValue.length === allBusinessUnits.length && !newValue.includes(ALL_BUSINESS_UNITS_ID));
}

/**
 * Condition to clear options:
 *   - Has previously selected all business units
 *   - All individual BU options are selected
 *   - "All business units" option is not selected
 */
export function getShouldClearOptions({
  allBusinessUnits,
  newValue,
  hasPreviouslySelectedAll
}) {
  const allOptionsExceptAllBUsOption = getHasSelectedAllOptionsExceptAllBUsOption({
    allBusinessUnits,
    newValue
  });
  return allOptionsExceptAllBUsOption && hasPreviouslySelectedAll;
}

/**
 * Condition to select all business units in the dropdown:
 *   - [1] Has not previously selected all options
 *   - [2] No previously BU option is selected and user clicked at "All business units" option OR
 *     - This is a special condition from ui-business-units-lib where it sends an undefined value
 *   - [3] User selected all individual BU options + "All business units" option OR
 *   - [4] 1+ BU option is selected (but not all) and user clicked at "All business units" option OR
 *   - [5] All individual BU options are selected and "All business units" option is not.
 */
export function getShouldSelectAllBusinessUnits({
  allBusinessUnits,
  newValue,
  hasPreviouslySelectedAll
}) {
  /**
   * Condition [1]
   */
  if (hasPreviouslySelectedAll) {
    return false;
  }

  /**
   * Condition [2]
   */
  if (newValue === undefined) {
    return true;
  }

  /**
   * Condition [3]
   */
  const allOptionsInDropdown = newValue.length === allBusinessUnits.length + 1;
  if (allOptionsInDropdown) {
    return true;
  }

  /**
   * Condition [4]
   */
  const hasSelectedAllBUs = newValue.includes(ALL_BUSINESS_UNITS_ID);
  if (hasSelectedAllBUs) {
    return true;
  }

  /**
   * Condition [5]
   */
  return getHasSelectedAllOptionsExceptAllBUsOption({
    allBusinessUnits,
    newValue
  });
}